import { IS_NATIVE } from '@/platform';

export const APP_VERSION = __APP_VERSION__;

export const APP_PLATFORM = IS_NATIVE ? 'android' : 'telegram';

const parts = (version: string): number[] =>
  version.split('.').map((part) => Number.parseInt(part, 10) || 0);

export function isOlder(version: string, minimum: string): boolean {
  const have = parts(version);
  const need = parts(minimum);
  for (let i = 0; i < Math.max(have.length, need.length); i++) {
    const gap = (have[i] ?? 0) - (need[i] ?? 0);
    if (gap !== 0) return gap < 0;
  }
  return false;
}
